import { render, staticRenderFns } from "./vuealerts.vue?vue&type=template&id=51c9f826&"
import script from "./vuealerts.vue?vue&type=script&lang=js&"
export * from "./vuealerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports